export default "__VITE_ASSET__5VCod5Rd__"